import { boTypesApi } from "./boTypes/api.core";
import { boOperationsApi } from "./operations/api.core";
import { boRightsApi } from "./rights/api.core";
import { boStatesApi } from "./states/api.core";

/**
 * Транспортный слой OMP для БО: типы, операции, состояния, права.
 */
export const boApi = {
    types: boTypesApi,
    operations: boOperationsApi,
    states: boStatesApi,
    rights: boRightsApi,
} as const;
